var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvailableData = function SvgAvailableData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.824 22.184-6.496-6.496 2.828-2.828 3.668 3.668 7.83-7.831 2.828 2.828zm15.161-7.897H39.75v4H26.985zm5.081 25.11-6.495-6.495 2.828-2.829 3.667 3.667 7.831-7.83 2.828 2.829zM8.25 31.501h12.766v4H8.25z"
  })));
};
export default SvgAvailableData;